import { CheckCircle2, Circle, Clock, AlertCircle } from 'lucide-react';

export default function TaskNode({ task, onComplete, onUncomplete }) {
  const isComplete = !!task.completedAt;
  const isWaiting = !isComplete && (task.waitingFor || task.delegatedTo);
  const isSomeday = !isComplete && task.isSomeday;
  const isScheduled = !isComplete && task.scheduledDate;

  const handleToggle = (e) => {
    e.stopPropagation();
    if (isComplete) {
      onUncomplete(task.id);
    } else {
      onComplete(task.id);
    }
  };

  return (
    <div
      className={`flex items-center gap-2 py-1.5 px-2 rounded-md hover:bg-surface-hover/50 transition-colors ${
        isComplete ? 'opacity-50' : ''
      }`}
    >
      {/* Checkbox */}
      <button
        onClick={handleToggle}
        className="flex-shrink-0 bg-transparent border-none cursor-pointer p-0"
      >
        {isComplete ? (
          <CheckCircle2 size={14} className="text-green-500" />
        ) : (
          <Circle size={14} className="text-text-muted hover:text-accent transition-colors" />
        )}
      </button>

      {/* Task title */}
      <span
        className={`text-[11px] flex-1 ${
          isComplete ? 'line-through text-text-muted' : 'text-text-secondary'
        }`}
      >
        {task.title}
      </span>

      {/* Status indicators */}
      {isWaiting && (
        <span className="flex items-center gap-1 text-[9px] text-amber-500 bg-amber-500/10 px-1.5 py-0.5 rounded">
          <AlertCircle size={10} />
          Waiting
        </span>
      )}
      {isSomeday && (
        <span className="text-[9px] text-text-tertiary bg-surface-hover px-1.5 py-0.5 rounded">
          Someday
        </span>
      )}
      {isScheduled && !isComplete && (
        <span className="flex items-center gap-1 text-[9px] text-blue-500 bg-blue-500/10 px-1.5 py-0.5 rounded">
          <Clock size={10} />
          Scheduled
        </span>
      )}
    </div>
  );
}
